import React, { useState, useEffect } from "react";
import {
  findUsers,
  getListFriends,
  getPendingFriendsRequests,
  sendFriendRequest,
  acceptFriendRequest,
  rejectFriendRequest,
} from "../../../api/User.api";
import "./style.scss";

const FriendPage = () => {
  const [search, setSearch] = useState("");
  const [randomUsers, setRandomUsers] = useState([]);
  const [myFriends, setMyFriends] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [users, friends, requests] = await Promise.all([
          findUsers(),
          getListFriends(),
          getPendingFriendsRequests(),
        ]);
        console.log("Fetched users:", users);
        console.log("Fetched friends:", friends);
        console.log("Fetched requests:", requests);
        setRandomUsers(Array.isArray(users.data) ? users.data : []);
        setMyFriends(Array.isArray(friends.data) ? friends.data : []);
        setPendingRequests(Array.isArray(requests.data) ? requests.data : []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearch = async () => {
    const keyword = search.trim().toLowerCase();
    if (keyword === "") {
      setSearchResults([]);
      setHasSearched(false);
    } else {
      try {
        const users = await findUsers();
        const filtered = users.filter(
          (user) =>
            user.name.toLowerCase().includes(keyword) ||
            user.email.toLowerCase().includes(keyword)
        );
        setSearchResults(filtered);
        setHasSearched(true);
      } catch (error) {
        console.error("Error searching users:", error);
      }
    }
  };

  const handleSendRequest = async (receiverId) => {
    try {
      await sendFriendRequest(receiverId);
      alert("Friend request sent!");
    } catch (error) {
      console.error("Error sending friend request:", error);
      alert("Failed to send friend request.");
    }
  };

  const handleAcceptRequest = async (senderId) => {
    try {
      await acceptFriendRequest(senderId);
      setPendingRequests((prev) =>
        prev.filter((request) => request.id !== senderId)
      );
      alert("Friend request accepted!");
    } catch (error) {
      console.error("Error accepting friend request:", error);
      alert("Failed to accept friend request.");
    }
  };

  const handleRejectRequest = async (senderId) => {
    try {
      await rejectFriendRequest(senderId);
      setPendingRequests((prev) =>
        prev.filter((request) => request.id !== senderId)
      );
      alert("Friend request rejected!");
    } catch (error) {
      console.error("Error rejecting friend request:", error);
      alert("Failed to reject friend request.");
    }
  };

  return (
    <div className="friend-page">
      <div className="search-friend">
        <input
          type="text"
          placeholder="Search friends by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      {hasSearched ? (
        <div className="friend-list">
          {searchResults.length > 0 ? (
            searchResults.map((user) => (
              <div key={user.id} className="friend-item">
                <div className="avatar-wrapper">
                  <img
                    src={user.avatar || "/default-avatar.jpeg"}
                    alt={user.name}
                  />
                </div>
                <span>{user.displayName}</span>
                <button onClick={() => handleSendRequest(user.id)}>
                  Add Friend
                </button>
              </div>
            ))
          ) : (
            <p className="no-result">No users found.</p>
          )}
        </div>
      ) : (
        <>
          <h3>Random Users</h3>
          <div className="friend-list">
            {randomUsers.length > 0 ? (
              randomUsers.map((user) => (
                <div key={user.id} className="friend-item">
                  <div className="avatar-wrapper">
                    <img
                      src={user.avatarUrl || "/default-avatar.jpeg"}
                      alt={user.displayName}
                    />
                  </div>
                  <span>{user.displayName}</span>
                  <button onClick={() => handleSendRequest(user.id)}>
                    Add Friend
                  </button>
                </div>
              ))
            ) : (
              <p className="no-result">No random users available.</p>
            )}
          </div>

          <h3>Pending Friend Requests</h3>
          <div className="friend-list">
            {pendingRequests.length > 0 ? (
              pendingRequests.map((request) => (
                <div key={request.id} className="friend-item">
                  <div className="avatar-wrapper">
                    <img
                      src={request.avatarUrl || "/default-avatar.jpeg"}
                      alt={request.displayName}
                    />
                  </div>
                  <span>{request.sender.displayName}</span>
                  <div className="btn-group-vertical">
                    <button onClick={() => handleAcceptRequest(request.id)}>Accept</button>
                    <button onClick={() => handleRejectRequest(request.id)}>Reject</button>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-result">No pending friend requests.</p>
            )}
          </div>

          <h3>Friends List</h3>
          <div className="friend-list">
            {myFriends.length > 0 ? (
              myFriends.map((friend) => (
                <div key={friend.id} className="friend-item">
                  <div className="avatar-wrapper">
                    <img
                      src={friend.avatarUrl || "/default-avatar.jpeg"}
                      alt={friend.displayName}
                    />
                  </div>
                  <span>{friend.displayName}</span>
                  <button>Unfriend</button>
                </div>
              ))
            ) : (
              <p className="no-result">No friends found.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default FriendPage;